import http from "./httpService";
import { apiUrl } from "../../config.js";

const apiEndpoint = apiUrl + "/commons/";

export function getInvifoThemes() {
  return http.get(apiEndpoint + "invifo-themes");
}

export function uploadAttachments(files) {
  return http.post(apiEndpoint + "attachments", files, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function getAttachments(docType, docID) {
  return http.get(apiEndpoint + `attachments/${docType}/${docID}`);
}

export function getMyAttachments() {
  return http.get(apiEndpoint + `myattachments`);
}

export function deleteAttachment(attachmentID) {
  return http.delete(apiEndpoint + "attachment/" + attachmentID);
}

export function saveNote(note) {
  return http.post(apiEndpoint + "note", note);
}

export function getNotes(docType, docID) {
  return http.get(apiEndpoint + `notes/${docType}/${docID}`);
}

export function deleteNote(noteID) {
  return http.delete(apiEndpoint + "note/" + noteID);
}

export function getWhatsappConnection() {
  return http.get(apiEndpoint + "whatsapp");
}

export function searchObjects(searchObject) {
  return http.post(apiEndpoint + "search-object", searchObject);
}

export function uploadSharedDocument(files) {
  return http.post(apiEndpoint + "shared-document", files, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function getSharedDocuments(docType, docID) {
  return http.get(apiEndpoint + `shared-documents/${docType}/${docID}`);
}

export function deleteSharedDocument(sharedDocumentID) {
  return http.delete(apiEndpoint + "shared-document/" + sharedDocumentID);
}

export function getRecycleBin() {
  return http.get(apiEndpoint + "recycle-bin");
}

export function savePredefinedTOC(predefinedTOC) {
  return http.post(apiEndpoint + "predefined-toc", predefinedTOC);
}

export function getPredefinedTOCs(appCode) {
  return http.get(apiEndpoint + `predefined-tocs/${appCode}`);
}

export function deletePredefinedTOC(predefinedTOCID) {
  return http.delete(apiEndpoint + "predefined-toc/" + predefinedTOCID);
}

export function saveDocumentCodePrefix(documentCodePrefix) {
  return http.post(apiEndpoint + "document-prefix", documentCodePrefix);
}

export function getDocumentCodePrefix(codePrefixID) {
  return http.get(apiEndpoint + `document-prefix/${codePrefixID}`);
}

export function downloadMassUploadTemplate(templateID) {
  return http.get(apiEndpoint + "download-mass-upload-template/" + templateID);
}

export function uploadMassUploadData(massUploadID, file) {
  return http.post(
    apiEndpoint + "upload-mass-upload-data/" + massUploadID,
    file,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

export function saveUploadedMassUpload(massUploadID, uploadedMassUpload) {
  return http.post(
    apiEndpoint + "save-uploaded-mass-upload/" + massUploadID,
    uploadedMassUpload
  );
}

export function deleteSelected(selectedData, tableName) {
  return http.post(apiEndpoint + "delete-selected/" + tableName, selectedData);
}

export function getCountriesOptionValues() {
  return http.get(apiEndpoint + "countries-option-values");
}
